// import { axiosPrivate } from "api/axios";
// import { AUTH_TOKEN, REFRESH_TOKEN } from "constants/AuthConstant";

// const AuthService = {};

// AuthService.login = function (data) {
//   return axiosPrivate({
//     method: "post",
//     url: "/auth/login",
//     data: data,
//   });
// };

// AuthService.refresh = function () {
//   return axiosPrivate({
//     method: "post",
//     url: "/auth/refresh",
//     data: {},
//     headers: {
//       Authorization: `Bearer ${localStorage.getItem(REFRESH_TOKEN)}`,
//     },
//   });
// };

// // AuthService.getUser = function () {
// //   return axiosPrivate({
// //     method: "get",
// //     url: "/users/currentUser",
// //     // data: {},
// //     headers: {
// //       Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN)}`,
// //     },
// //   });
// // };
// AuthService.getUser = function () {
//   const token = localStorage.getItem(AUTH_TOKEN);
//   console.log("Token envoyé :", token); // <-- Vérifier si le token est bien là

//   return axiosPrivate({
//     method: "get",
//     url: "/users/currentUser",
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };



// AuthService.register = function (data) {
//   return axiosPrivate({
//     method: "post",
//     url: "/users/register",
//     data: data,
//   });
// };

// AuthService.logout = function (token) {
//   return axiosPrivate({
//     method: "post",
//     url: "/auth/logout",
//     data: {},
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

// // AuthService.loginInOAuth = function () {
// //   return fetch({
// //     url: "/auth/loginInOAuth",
// //     method: "post",
// //   });
// // };

// export default AuthService;




import { axiosPrivate } from "api/axios";
import { AUTH_TOKEN, REFRESH_TOKEN } from "constants/AuthConstant";
import Cookies from "js-cookie";

const AuthService = {};

AuthService.login = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/auth/login",
    data: data,
  });
};

AuthService.refresh = function () {
  return axiosPrivate({
    method: "post",
    url: "/auth/refresh",
    data: {},
    headers: {
      Authorization: `Bearer ${Cookies.get(REFRESH_TOKEN)}`,
    },
  });
};

AuthService.getUser = function () {
  const token = Cookies.get(AUTH_TOKEN);
  console.log("Token envoyé :", token); // <-- Vérifier si le token est bien là

  return axiosPrivate({
    method: "get",
    url: "/users/currentUser",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

AuthService.register = function (data) {
  return axiosPrivate({
    method: "post",
    url: "/users/register",
    data: data,
  });
};

AuthService.logout = function (token) {
  return axiosPrivate({
    method: "post",
    url: "/auth/logout",
    data: {},
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export default AuthService;